import "../styles/ActionLabel.scss";

import IdleImg from '../assets/action-idle.png';
import WaitImg from '../assets/action-waiting.png';
import HoldImg from '../assets/action-hold.png';
import SpinImg from '../assets/action-spinning.png';
import CompleteImg from '../assets/action-complete.png';
import Loss1Img from '../assets/action-loss-1.png';
import Loss2Img from '../assets/action-loss-2.png';
import Loss3Img from '../assets/action-loss-3.png';
import Win1Img from '../assets/action-win1.png';
import Win1Img3 from '../assets/action-win1-3.png';
import Win2Img1 from '../assets/action-win2-1.png';
import Win2Img2 from '../assets/action-win2-2.png';
import Win2Img3 from '../assets/action-win2-3.png';
import Win3Img1 from '../assets/action-win3-1.png';
import Win3Img2 from '../assets/action-win3-2.png';
import Win3Img3 from '../assets/action-win3-3.png';

const sorryMessages = [null,'Sorry Partner,','So Close','Spin Again'];
const sorryImgs = [null,Loss1Img,Loss2Img,Loss3Img];
const winMessages = {
    'vvv' : [null,'Congratulations!','You Won!','7s pays Graphic Tee'],
    'hhh' : [null,'Congratulations!','You Won!','Hats pays Cowboy Hat'],
    'bbb' : [null,'Congratulations!','Triple Jackpot!','You Struck Gold!']
}
const winImgs = {
    'vvv' : [null,Win1Img,Win2Img1,Win3Img1],
    'hhh' : [null,Win1Img,Win2Img2,Win3Img2],
    'bbb' : [null,Win1Img3,Win2Img3,Win3Img3]
}

export default function ActionLabel( {position, gameState, result}){
    

    const getSpinState = () => {
        if (gameState!==2) return '';
        if (result){
            if (result.indexOf('-')>-1) return '';
            if (result.length>=position) return 'active';
        }
        return '';
    }
    const getSpinMessage = () => {
        if (gameState!==2) return "";
        return "Spinning";
        // return "Hold Tight";
    }
    const getSpinImg = () => {
        if (gameState!==2) return null;
        if (position===1) {
            if (!result || result.length===0) return HoldImg;
            if (result.substring(0,1)==='-') return SpinImg;
            return CompleteImg;
        } else if (position===2) {
            if (!result || result.length===0) {
                return HoldImg;
            } else if (result.length===1) {
                if (result.substring(0,1)!=='-') return SpinImg;
                return HoldImg;
            } else {
                if (result.substring(1,2)==='-') return SpinImg;
            }
            return CompleteImg;
        } else if (position===3) {
            if (!result || result.length===0) {
                return HoldImg;
            } else if (result.length<=2) {
                if (result.indexOf('-')>-1) return HoldImg;
                return SpinImg;
            } else {
                if (result.indexOf('-')>-1) return SpinImg;
            }
            return CompleteImg;
        }
        return null;
    }
    const getWinState = () => {
        if (gameState!==3) return '';
        if (result==='vvv') return 'win1';
        if (result==='hhh') return 'win2';
        if (result==='bbb') return 'win3';
        return 'loss';
    }

    return (
        <div className={`actionLabel p-${position} ${getSpinState()==='active'?'dark':''} ${getWinState()==='loss'?'dark':''} ${getWinState().indexOf('win')>-1?'gold':''}`}>
            <img className={gameState===0?'active':''} alt="Spin To Win" src={IdleImg} />
            <img className={gameState===1?'active':''} alt="Press To Play" src={WaitImg} />
            {/* <img className={gameState===2&&'active'} alt="Hold Tight" src={HoldImg} /> */}
            <img className={gameState===2?'active':''} alt={getSpinMessage()} src={getSpinImg()} />
            {/* <img className={getSpinState()} alt="Complete" src={CompleteImg} /> */}
            <img className={getWinState()==='loss'?'active':''} alt={sorryMessages[position]} src={sorryImgs[position]} />
            <img className={getWinState().indexOf('win')>-1?'active':''} alt={getWinState().indexOf('win')>-1?winMessages[result][position]:''} src={getWinState().indexOf('win')>-1?winImgs[result][position]:null} />
        </div>
    )
}